<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="(size*13)/15"
    viewBox="0 0 15 13"
  ><g><g><path
    :fill="color"
    d="M12.791 10.908a.367.367 0 0 1-.367.367H2.101a.367.367 0 0 1-.367-.367V5.096l.585 1.756c.15.45.57.753 1.045.753h2.064v.367c0 .203.164.367.367.367H8.73a.367.367 0 0 0 .367-.367v-.367h2.065a1.1 1.1 0 0 0 1.044-.753l.585-1.756zM8.363 6.87v.734H6.162v-.734zm4.286-3.67l-1.14 3.42c-.05.15-.19.25-.347.25H9.097v-.367a.367.367 0 0 0-.367-.367H5.795a.367.367 0 0 0-.367.367v.367H3.364a.366.366 0 0 1-.348-.25L1.876 3.2zm-7.221-1.1c0-.202.165-.367.367-.367H8.73c.203 0 .367.165.367.367v.367h-3.67zm7.733.367H9.83V2.1c0-.607-.494-1.101-1.1-1.101H5.794c-.607 0-1.101.494-1.101 1.1v.368H1.367A.368.368 0 0 0 1 2.835v8.073c0 .607.494 1.1 1.1 1.1h10.324c.607 0 1.101-.493 1.101-1.1V2.84c-.014-.24-.162-.372-.364-.373z"
  /><path
    fill="none"
    :stroke="color"
    stroke-miterlimit="50"
    stroke-width=".2"
    d="M12.791 10.908a.367.367 0 0 1-.367.367H2.101a.367.367 0 0 1-.367-.367V5.096l.585 1.756c.15.45.57.753 1.045.753h2.064v.367c0 .203.164.367.367.367H8.73a.367.367 0 0 0 .367-.367v-.367h2.065a1.1 1.1 0 0 0 1.044-.753l.585-1.756zM8.363 6.87v.734H6.162v-.734zm4.286-3.67l-1.14 3.42c-.05.15-.19.25-.347.25H9.097v-.367a.367.367 0 0 0-.367-.367H5.795a.367.367 0 0 0-.367.367v.367H3.364a.366.366 0 0 1-.348-.25L1.876 3.2zm-7.221-1.1c0-.202.165-.367.367-.367H8.73c.203 0 .367.165.367.367v.367h-3.67zm7.733.367H9.83V2.1c0-.607-.494-1.101-1.1-1.101H5.794c-.607 0-1.101.494-1.101 1.1v.368H1.367A.368.368 0 0 0 1 2.835v8.073c0 .607.494 1.1 1.1 1.1h10.324c.607 0 1.101-.493 1.101-1.1V2.84c-.014-.24-.162-.372-.364-.373z"
  /></g></g></svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
